// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TypeStep-card-828c{align-items:center;gap:40px;padding:64px;border-radius:16px;background-color:var(--ui-background-color-soft)}`, "",{"version":3,"sources":["webpack://./src/page/ProfileScreen/BasicSelfiesPanel/TypeStep.module.scss"],"names":[],"mappings":"AAAA,oBACE,kBAAA,CACA,QAAA,CACA,YAAA,CACA,kBAAA,CACA,gDAAA","sourcesContent":[".card {\n  align-items: center;\n  gap: 40px;\n  padding: 64px;\n  border-radius: 16px;\n  background-color: var(--ui-background-color-soft);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `TypeStep-card-828c`
};
module.exports = ___CSS_LOADER_EXPORT___;
